import api from 'Application/api/api';

const getContractsFilterRange = signal =>
	api.get('/client-contracts/filters-range', {
		signal,
	});

export default getContractsFilterRange;
